import "./MapMarkersPopover.scss"

import React, { FunctionComponent } from "react"

import Text from "components/Text/Text"
import NoValue from "components/NoValue/NoValue"
import { IMapMarkerProps } from "components/MapView/MapMarker/MapMarker"

interface IMapMarkersPopoverProps {
    markers: IMapMarkerProps[]
}

const MapMarkersPopover: FunctionComponent<React.PropsWithChildren<IMapMarkersPopoverProps>> = ({
    markers
}) => {
    return (
        <div className="map-markers-popover">
            <div className="map-markers-popover__content">
                {markers.map((marker, idx) => {
                    return <div key={idx}
                        className={`map-markers-popover__item ${!!marker.onClick ? 'map-markers-popover__item--clickable' : ''}`}
                        onClick={marker.onClick}>
                        <Text>{marker.content || marker.title || <NoValue />}</Text>
                    </div>
                })}
            </div>
        </div>
    )
}

export default MapMarkersPopover
